import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import "./onboarding.css";
import { fetchStudentDetails } from "../../actions/student.action";
import ButtomButton from "../../components/DocButtomButton";
import CustomInput from "../../components/CustomInput";
import ErrorInputComponent from "../../components/ErrorInputComponent";
import { Loading } from "../../utils/helpers/constants";

export default function ActivateAccount() {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    profile: { userData },
  } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const {
    student: { activateUserLoading },
  } = useSelector(({ studentReducer }) => ({
    student: studentReducer,
  }));

  if (userData.accountStatus === "ACTIVATED") {
    history.push("/dashboard");
  }

  const btnLoadState = activateUserLoading === Loading.FETCHING;

  const validationSchema = Yup.object({
    matricNumber: Yup.string().required("Matric number is required"),
  });
  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      matricNumber: "",
    },
    validationSchema,
    onSubmit(values) {
      const navigateLink = () => history.push("/onboarding/verify-profile");
      dispatch(fetchStudentDetails(values.matricNumber, navigateLink));
    },
  });

  return (
    <div className="flex flex-column justify-center">
      <div className="App-height p-5 md:w-1/3">
        <div className="">
          <AiOutlineClose
            size={25}
            className="mt-5 cursor-pointer"
            onClick={() => history.goBack()}
          />
          <h1 className="a_acc_header mt-5">Activate your account</h1>
          <p className="a_acc_header_text">
            You should create an exceptional experience when you do things
          </p>
        </div>
        <form>
          <div className="mt-10 mb-10">
            <CustomInput
              name="matricNumber"
              handleChange={handleChange}
              placeholder="Matric No."
            />
            <ErrorInputComponent error={errors.matricNumber} />
          </div>
        </form>
        <ButtomButton
          loading={btnLoadState}
          name={"Get Started"}
          func={() => handleSubmit()}
        />
      </div>
    </div>
  );
}
